import {
  Stack,
  FileInput,
  Card,
  FlexSpacer,
  SelectGroup
} from '@efast_public/fjd-component-library';
import { Dispatch } from 'react';
import {
  ActionType,
  FileUploadAction
} from '../../api/models/UploadFiles/FileUploadAction';
import { UploadFiles } from '../../api/models/UploadFiles/UploadFiles';
import UploadsList from '../../pages/shared/UploadsList';

interface DecideApplicationDigitalProps {
  readonly isApplicationExaminedAndChecked: boolean;
  readonly setIsApplicationPositiveDecided: (
    isPositiveDecided: boolean | undefined
  ) => void;
  readonly isApplicationPositiveDecided: boolean | undefined;
  readonly fileDispatch: Dispatch<FileUploadAction>;
  readonly filesUploadstate: UploadFiles;
}

export default function DecideApplicationDigital(
  props: DecideApplicationDigitalProps
) {
  const filesUploadstate: UploadFiles = props.filesUploadstate;
  return (
    <span>
      <Stack direction={'column'} spacing="md">
        <div
          style={{
            color: props.isApplicationExaminedAndChecked ? '#333333' : '#999999'
          }}
          id={'upload_heading'}
        >
          Um den Antrag zu bescheiden laden Sie bitte einen Bescheid hoch und
          geben Sie an, ob der Bescheid positiv oder negativ ist
        </div>
        <div
          style={{
            color: props.isApplicationExaminedAndChecked
              ? '#333333'
              : '#999999',
            fontWeight: 700,
            fontSize: '0.97rem'
          }}
          id={'bescheid_heading'}
        >
          Bescheidupload
        </div>
        {(props.isApplicationExaminedAndChecked &&
          filesUploadstate.additionalFiles.length > 0) ||
        filesUploadstate.bescheidUpload ? (
          <UploadsList
            applicationIsPositiveDecided={props.isApplicationPositiveDecided}
            setApplicationIsPositiveDecided={
              props.setIsApplicationPositiveDecided
            }
            uploadFiles={filesUploadstate}
            dispatch={props.fileDispatch}
            hasUploadButtonEnabled={true}
            uploadButtonTextAtLeastOneFileUploaded={
              'Weiteres Dokument hinzufügen'
            }
            showPreview={true}
            hasBescheidSelect={true}
            hasIconsRightAligned={true}
          />
        ) : (
          <Card>
            <Stack direction="row">
              <FileInput
                disabled={
                  props.isApplicationExaminedAndChecked === undefined ||
                  props.isApplicationExaminedAndChecked === false
                }
                id="application_upload_button"
                label="Bescheid hochladen"
                name="application_upload_button"
                onChange={(files) => {
                  props.fileDispatch({
                    type: ActionType.ADD_BESCHEID,
                    files: files
                  });
                }}
              />
              <FlexSpacer />
              <SelectGroup
                id="btn-select-group-upload-bescheid-digital"
                name="result"
                selectType="single"
                disabled={
                  props.isApplicationExaminedAndChecked === undefined ||
                  props.isApplicationExaminedAndChecked === false
                }
              >
                <SelectGroup.Button
                  checked={props.isApplicationPositiveDecided ?? false}
                  value="positive"
                  label={"✓ Positiv"}
                  onClick={() => {
                    props.setIsApplicationPositiveDecided(
                      props.isApplicationPositiveDecided === true
                        ? undefined
                        : true
                    );
                  }}
                />
                <SelectGroup.Button
                  checked={
                    props.isApplicationPositiveDecided !== undefined &&
                    !props.isApplicationPositiveDecided
                  }
                  label={"✗ Negativ"}
                  value="negative"
                  onClick={() => {
                    props.setIsApplicationPositiveDecided(
                      props.isApplicationPositiveDecided === false
                        ? undefined
                        : false
                    );
                  }}
                />
              </SelectGroup>
            </Stack>
          </Card>
        )}
      </Stack>
    </span>
  );
}
